export interface ITagPickerDemoPageState {
  isPickerDisabled?: boolean;
}
